import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Expander } from '@sm360/ui-library'

import InvoiceItem from '../invoice-item/InvoiceItem'

const InvoiceExpendable = ({ item }) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const { items, category, name, amount, isCardLayout } = item

    const classNames = clsx('pc-invoiceExpendable', category && `-${category}`, isCardLayout && '-card')

    return (
        <Expander
            id={category}
            name={category}
            className={classNames}
            iconPosition='right'
            trigger={
                <div className='pc-invoiceExpendable__head'>
                    <InvoiceItem slug={category} label={name} amount={amount} />
                </div>
            }
            isOpen={isOpen}
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className='pc-invoiceExpendable__panel'>
                {items.map(({ description, amount }) => {
                    return (
                        <div key={`${category}-${description}`} className='pc-invoiceExpendable__item'>
                            <InvoiceItem slug={`${category}-${description}`} label={description} amount={amount} />
                        </div>
                    )
                })}
            </div>
        </Expander>
    )
}

InvoiceExpendable.propTypes = {
    item: PropTypes.object,
}

InvoiceExpendable.defaultProps = {
    item: {},
}

export default InvoiceExpendable
